import { useState } from 'react'
import Components from '@cloudmeet/web-components'
const { error } = Components.Utils.Notifications

type SendQueryRequestOptions = {
  showErrors: boolean
}

export default () => {
  const [isLoading, setIsLoading] = useState(false)

  const sendQueryRequest = async <T>(func: Function, opts?: SendQueryRequestOptions): Promise<T | null> => {
    try {
      setIsLoading(true)
      const result = await func()
      setIsLoading(false)
      return result
    } catch (err) {
      setIsLoading(false)
      const displayErrors = !opts || opts.showErrors
      if (displayErrors) {
        await error('An error occurred while getting the data.')
      }
      return null
    }
  }

  return {
    isLoading,
    sendQueryRequest,
  }
}
